<template>
  <div></div>
</template>

<script>
  export default {
      name: "getopenid",
      data(){
          return {
          }
      },
      methods:{
          /**
           * 获取URL参数
           * @returns {Object}
           */
          getUrlCode(){
              var url = location.search
              var theRequest = new Object()
              if (url.indexOf("?") != -1){
                  var str = url.substr(1)
                  var strs = str.split("&")
                  for(var i = 0; i < strs.length; i ++){
                      theRequest[strs[i].split("=")[0]]=(strs[i].split("=")[1])
                  }
              }
              return theRequest
          },
          getUserInfoByCode(){
            this.axios.get('/api/appweb/wxpay/getUserInfoByCode?code=' + this.code).then(res => {
              var openid = res.data.data.openid;
              sessionStorage.setItem('openid', openid);
              // console.log(res);
              var meetingCode = sessionStorage.getItem('meetingCode');
              this.$router.push("/Guide/index?meetingCode="+meetingCode)
            });
          }

      },
      mounted() {
          var local = window.location.href; // 获取页面url
          if(process.env.API_ROOT == 'https://meeting.ejectu.com'){
            var appid = 'wxb6f979941a7e9ef7';
          }else{
            var appid = 'wxf10c045e4ea571fe';
          }
          this.code = this.getUrlCode().code;// 截取code
          if (this.code == null || this.code === ''){
              window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`;
          }else{
            this.getUserInfoByCode();
          }

      }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/getWxOpenId/index.vue